import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';
import { FloorPlans } from '@/pages/floor-plans';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/floor-plans'
)({
  validateSearch: zodValidator(
    z.object({
      view: fallback(z.enum(['all', 'gallery']).optional(), 'all'),
    })
  ),
  component: FloorPlans,
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="floorPlans" /> },
});
